module.exports = __webpack_public_path__ + "images/multi5129e5c4e35dab00f6eba35d1eb409f9.svg";